import api from "../axios";
import { RoamingApiStruct, RoamingZoneStruct } from "@/struct/RoaminStruct";

export const GetZoneByUuid = async (uuid = "" as string) => {
  return await api
    .post<RoamingApiStruct<RoamingZoneStruct>>(
      "/api/public/roaming/get-zone-by",
      { uuid }
    )
    .then((res) => {
      if (res.data.status) return res.data.data;
      else throw res.data;
    })
    .catch((err) => {
      throw err;
    });
};
